<template lang="html">
  <v-app>
    <v-content id="AuthWrapper">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>

          <v-flex xs12 sm8 md4>
            
            <form @submit.prevent='sendForm'>
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title v-text="resetPassword ? 'Passwort vergessen?' : 'Anmelden'"/>
                </v-toolbar>
                <v-card-text>
                  <v-alert :value="!!error" type="error" class="press">
                    {{error}}
                  </v-alert>
                  <v-alert :value="true" type="error" class="press" v-for='(error,idx) in $store.state.loginErrors' :key="'error'+idx" v-html="error"/>
                  <v-form>
                    <v-text-field label="E-Mail" name="email" prepend-icon="mail_outline" v-model="userEmail" type="email" autocomplete="sport-username"/>
                    <v-text-field label="Passwort" name="password" prepend-icon="lock_outline" v-model="userPassword" type="password" v-if="!resetPassword" autocomplete="sport-password"/>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat small color="grey" @click.prevent="toggleForgotPassword" v-text="resetPassword ? 'zurück zum Login' : 'Passwort vergessen?'"/>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit" v-text="resetPassword ? 'Passwort zurücksetzen' : 'Login'"/>
                </v-card-actions>
              </v-card>
            </form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-content v-if="3 === 4" id="AuthWrapper" class="login">

      <div class="centerBox box padded dark">

        <h1 v-if='resetPassword'>Passwort vergessen</h1>
        <h1 v-else>Anmelden</h1>
        
        <ui-spinner v-if='isPending'/>

        <div v-else>

          <div class="alert alert-secondary" v-if='message'>{{message}}</div>
          <div class="alert alert-danger" v-for='error in   $store.state.loginErrors'>
            {{error}}
          </div>

          <form @submit.prevent='doResetPassword' v-if='resetPassword'>
            
            <br/>
            <v-text-field label="E-Mail" prepend-icon="mail_outline" v-model="userEmail" type="email" autocomplete="sport-username"/>
            <br/>
            
            <v-btn type='submit' color="primary" v-text="'Passwort zurücksetzen'"/>
            <div class='clearfix'></div>
            <br/>
            <v-btn flat small @click.prevent='toggleForgotPassword' v-text="'zurück zum Login'" />

          </form>
          <form @submit.prevent='doLogin' class="cform" v-else>

            <br/>
            <v-text-field label="E-Mail" prepend-icon="mail_outline" v-model="userEmail" type="email" autocomplete="sport-username"/>
            <v-text-field label="Passwort" prepend-icon="lock_outline" v-model="userPassword" type="password" autocomplete="sport-password"/>
            <br/>

            <v-btn type='submit' color="primary" v-text="'login'"/>
            <div class='clearfix'></div>
            <br/>
            <v-btn flat small @click.prevent='toggleForgotPassword' v-text="''" />

          </form>

        </div>

      </div>

    </v-content>
  </v-app>
</template>

<script>
import axios        from 'axios'
import UiSpinner    from '@/components/ui/Spinner'
import LabeledField from '@/components/ui/LabeledField'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  mounted(){

  },
  data() {
    return {
      userName: '',
      userEmail: '',
      userPassword: '',
      resetPassword: false,
      message: '',
      error: ''
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isPending(){
      return this.$store.getters.isPending
    },
    errors() {
      let errors = this.$store.state.loginErrors
      return  errors
    },
    loginError(){
      return this.$store.getters.getLoginErrors
    },
  },
  created () {
    this.checkCurrentLogin()
  },
  activated(){
    this.checkCurrentLogin()
  },
  updated () {
    this.checkCurrentLogin()
  },
  methods: {
    update(){
      console.log('update');
    },
    doResetPassword(){
      this.$store.dispatch('resetPassword', {
        email: this.userEmail,
      }).then((resp)=> {
        console.log('reset response', resp);
        console.log('reset response', resp.data.message);
        if(resp.status === 200){
          this.message = resp.data.message
        }
      })
    },
    doLogin(){
      console.log('login', this.user);
      this.$store.dispatch('login', {
        email: this.userEmail,
        password: this.userPassword
      }).then((resp)=> {
        console.log('login response in login comp', resp);
        this.message = resp.data.message
        if(resp && resp.status === 200){
          this.$router.push('/')
        }
      }).catch((error) => {
        console.log("Error", error)
        this.error = error.data.error.message
      })
    },
    sendForm() {
      if (this.resetPassword) {
        this.doResetPassword()
      } else {
        this.doLogin()
      }
    },
    toggleForgotPassword(){
      console.log('forgot password');
      this.resetPassword = !this.resetPassword
      return false
    },
    checkCurrentLogin () {
      let logedInRoute = "/";
      if (this.currentUser) {
        this.$router.push(logedInRoute)
      }
    }
  },
  components: {
    UiSpinner,
    LabeledField
  }

}
</script>

<style lang="scss">
.login {
  height: 100vh;
  display: grid;
  & > * { /* thing to center */
    margin: auto;
  }
  background: #222;
}

.msg {

}

#AuthWrapper {
  background: transparent url('../assets/images/sports_blur.png') left top repeat;
}


</style>
